const facts = [
  "In real estate since 2011",
  "Licensed real estate broker",
  "Licensed Mortgage Loan Originator, NMLS #2512081",
  "Builder of Fresh Vision OS",
];

const ProofBar = () => (
  <section className="bg-[#0D1B2A] border-y border-[#C5A059]/25 py-6">
    <div className="container mx-auto px-6">
      <ul className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
        {facts.map((fact) => (
          <li
            key={fact}
            className="text-white/85 text-[0.78rem] md:text-[0.85rem] tracking-wide flex items-center gap-3"
          >
            <span className="h-1.5 w-1.5 rounded-full bg-[#C5A059]" aria-hidden="true" />
            {fact}
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default ProofBar;
